<template>
  <div>
    <section id="wrapper">
      <div id="content-wrapper" class="col-xs-12">
        <section id="main">
          <section id="content" class="content_v1">
            <div class="slider-banner clearfix">
              <div class="slider-layout-1">
                <div id="spattributessearch" class="spas-wrap">
                  <div
                    class="searchbackground searchbackground-mobile"
                    style="
                      background-repeat: no-repeat;
                      padding-left: 5px;
                      padding-right: 5px;
                      padding-top: 15px;
                      padding-bottom: 45px;
                      background-color: white;
                      background-position: right 0px bottom 0px;
                      background-size: cover;
                      height: 640px !important;
                    "
                  >
                  <div class="row row-padding-top">
    <div class="col-4 d-flex justify-content-center">
      <router-link to="/ajouterBlocNote">
        <img src="nooo.png" class="img-fluid imga_note" alt="Bloc Note" />
      </router-link>
    </div>
    <div class="col-4 d-flex justify-content-center">
      <router-link to="/ajouterService">
        <img src="se.jpg" class="img-fluid img-fixed" alt="Service" />
      </router-link>
    </div>
    <div class="col-4 d-flex justify-content-center">
      <router-link to="/ajouter_vid_man">
        <img src="vi.jpg" class="img-fluid img-fixed" alt="Vidéo" />
      </router-link>
    </div>
  </div>

<!-- recherche -->
                    <div class="row" style="padding-top: 15px">
                      <div class="col-xs-0 col-sm-0 col-md-2 col-lg-4"></div>

                      <div class="col-xs-12 col-sm-12 col-md-8 col-lg-4">
                        <div
                          class="tab-content"
                          style="
                            background-color: #555250c4;
                            border: 0px solid #f8c635;
                            border-top: 0px;
                            border-radius: 0px 0px 5px 5px;
                            box-shadow: 0px 1px 5px 2px #f8c635;
                          "
                        >
                          <div
                            class="tab-pane active"
                            id="bloc-search-with-reg"
                            aria-expanded="true"
                          >
                            <div
                              class="row"
                              style="
                                padding: 0px 0px 0px 0px;
                                text-align: center;
                                margin: auto;
                              "
                            >
                              <form
                                method="get"
                                action=""
                                onsubmit="return mySubmitFunction(event,'registration')"
                                class="spas-form spas-form-center"
                                style=""
                              >
                                <div
                                  style="list-style: none"
                                  class="d-flex justify-content-between"
                                >
                                  <li
                                    v-if="
                                      showTU == true &&
                                      showRS == false &&
                                      showDawla == false
                                    "
                                    class=""
                                    id="TU"
                                    @click="showTU != showTU"
                                    style="
                                      font-size: 25px;
                                      color: rgb(248, 198, 53);
                                      cursor: pointer;
                                    "
                                  >
                                    <i
                                      @click="showTU != showTU"
                                      id="TUi"
                                      class="fa fa-dot-circle-o"
                                      style="margin-right: 10px"
                                    ></i
                                    ><span
                                      @click="showTU != showTU"
                                      style="font-size: 14px"
                                      ><i>Matr</i></span
                                    >
                                    TU
                                  </li>

                                  <li
                                    v-if="showTU == true"
                                    class=""
                                    id="RS"
                                    @click="
                                      showTU = !showTU;
                                      showRS = !showRS;
                                    "
                                    style="
                                      font-size: 25px;
                                      cursor: pointer;
                                      color: rgb(255, 255, 255);
                                    "
                                  >
                                    <!--  class="fa fa-dot-circle-o" -->
                                    <i
                                      @click="
                                        showTU = !showTU;
                                        showRS = !showRS;
                                      "
                                      id="RSi"
                                      class="fa fa-circle-o"
                                      style="margin-right: 10px"
                                    ></i
                                    ><span
                                      @click="
                                        showTU = !showTU;
                                        showRS = !showRS;
                                      "
                                      style="font-size: 14px"
                                      ><i>Matr</i></span
                                    >
                                    RS
                                  </li>

                                  <li
                                    v-if="
                                      showTU == true &&
                                      showRS == false &&
                                      showDawla == false
                                    "
                                    class=""
                                    id="RS"
                                    @click="
                                      showTU = false;
                                      showRs = false;
                                      showDawla = true;
                                    "
                                    style="
                                      font-size: 25px;
                                      cursor: pointer;
                                      color: rgb(255, 255, 255);
                                    "
                                  >
                                    <!--  class="fa fa-dot-circle-o" -->
                                    <i
                                      @click="
                                        showTU = false;
                                        showRs = false;
                                        showDawla = true;
                                      "
                                      id="RSi"
                                      class="fa fa-circle-o"
                                      style="margin-right: 10px"
                                    ></i
                                    ><span
                                      @click="
                                        showTU = false;
                                        showRs = false;
                                        showDawla = true;
                                      "
                                      style="font-size: 14px"
                                      ><i>Matr</i></span
                                    >
                                    AD
                                  </li>

                                  <!--  RS -->

                                  <li
                                    v-if="
                                      showTU == false &&
                                      showRS == true &&
                                      showDawla == false
                                    "
                                    class=""
                                    id="TU"
                                    @click="
                                      showRS = !showRS;
                                      showTU = !showTU;
                                    "
                                    style="
                                      font-size: 25px;
                                      cursor: pointer;
                                      color: rgb(255, 255, 255);
                                    "
                                  >
                                    <i
                                      @click="
                                        showRS = !showRS;
                                        showTU = !showTU;
                                      "
                                      id="TUi"
                                      class="fa fa-circle-o"
                                      style="margin-right: 10px"
                                    ></i
                                    ><span
                                      @click="
                                        showRS = !showRS;
                                        showTU = !showTU;
                                      "
                                      style="font-size: 14px"
                                      ><i>Matr</i></span
                                    >
                                    TU
                                  </li>

                                  <li
                                    v-if="
                                      showTU == false &&
                                      showRS == true &&
                                      showDawla == false
                                    "
                                    class=""
                                    id="RS"
                                    style="
                                      font-size: 25px;
                                      color: rgb(248, 198, 53);
                                      cursor: pointer;
                                    "
                                  >
                                    <i
                                      id="RSi"
                                      class="fa fa-dot-circle-o"
                                      style="margin-right: 10px"
                                    ></i
                                    ><span style="font-size: 14px"
                                      ><i>Matr</i></span
                                    >
                                    RS
                                  </li>

                                  <li
                                    v-if="
                                      showTU == false &&
                                      showRS == true &&
                                      showDawla == false
                                    "
                                    class=""
                                    id="RS"
                                    @click="
                                      showRS = !showRS;
                                      showTU = false;

                                      showDawla = true;
                                    "
                                    style="
                                      font-size: 25px;
                                      cursor: pointer;
                                      color: rgb(255, 255, 255);
                                    "
                                  >
                                    <!--  class="fa fa-dot-circle-o" -->
                                    <i
                                      @click="
                                        showRS = !showRS;
                                        showTU = false;

                                        showDawla = true;
                                      "
                                      id="RSi"
                                      class="fa fa-circle-o"
                                      style="margin-right: 10px"
                                    ></i
                                    ><span
                                      @click="
                                        showRS = !showRS;
                                        showTU = false;

                                        showDawla = true;
                                      "
                                      style="font-size: 14px"
                                      ><i>Matr</i></span
                                    >
                                    AD
                                  </li>

                                  <!-- AD -->

                                  <li
                                    v-if="
                                      showTU == false &&
                                      showRS == false &&
                                      showDawla == true
                                    "
                                    class=""
                                    id="TU"
                                    @click="
                                      showTU = true;
                                      showRs = false;
                                      showDawla = false;
                                    "
                                    style="
                                      font-size: 25px;
                                      cursor: pointer;
                                      color: rgb(255, 255, 255);
                                    "
                                  >
                                    <i
                                      @click="
                                        showTU = true;
                                        showRs = false;
                                        showDawla = false;
                                      "
                                      id="TUi"
                                      class="fa fa-circle-o"
                                      style="margin-right: 10px"
                                    ></i
                                    ><span
                                      @click="
                                        showTU = true;
                                        showRs = false;
                                        showDawla = false;
                                      "
                                      style="font-size: 14px"
                                      ><i>Matr</i></span
                                    >
                                    TU
                                  </li>

                                  <li
                                    v-if="
                                      showTU == false &&
                                      showRS == false &&
                                      showDawla == true
                                    "
                                    class=""
                                    id="RS"
                                    @click="
                                      showTU = !showTU;
                                      showRs = !showTU;
                                      showDawla = !showTU;
                                    "
                                    style="
                                      font-size: 25px;
                                      color: rgb(255, 255, 255);
                                      cursor: pointer;
                                    "
                                  >
                                    <i
                                      @click="
                                        showTU = !showTU;
                                        showRs = !showTU;
                                        showDawla = !showTU;
                                      "
                                      id="RSi"
                                      class="fa fa-circle-o"
                                      style="margin-right: 10px"
                                    ></i
                                    ><span
                                      @click="
                                        showTU = !showTU;
                                        showRs = !showTU;
                                        showDawla = !showTU;
                                      "
                                      style="font-size: 14px"
                                      ><i>Matr</i></span
                                    >
                                    RS
                                  </li>

                                  <li
                                    v-if="
                                      showTU == false &&
                                      showRS == false &&
                                      showDawla == true
                                    "
                                    class=""
                                    id="RS"
                                    @click="
                                      showTU = !showTU;
                                      showRS = !showRS;
                                      showDawla = !showDawla;
                                    "
                                    style="
                                      font-size: 25px;
                                      cursor: pointer;

                                      color: rgb(248, 198, 53);
                                    "
                                  >
                                    <!--  class="fa fa-dot-circle-o" -->
                                    <i
                                      id="RSi"
                                      class="fa fa-dot-circle-o"
                                      style="margin-right: 10px"
                                    ></i
                                    ><span style="font-size: 14px"
                                      ><i>Matr</i></span
                                    >
                                    AD
                                  </li>
                                </div>

                                <div
                                  v-if="showTU == true && showRS == false"
                                  style="padding: 20px 0px 0px; margin: auto"
                                  class=""
                                >
                                  <div
                                    style="padding-bottom: 10px; display: block"
                                    id="blockMatTU"
                                  >
                                    <div
                                      style="
                                        height: 57px;
                                        width: 272px;

                                        background-image: url('matricule_moez.png');
                                        position: relative;
                                        margin: auto;
                                      "
                                    >
                                      <input
                                        placeholder="* * *"
                                        v-model="c1"
                                        type="text"
                                        id="numSerie"
                                        min="1"
                                        max="999"
                                        maxlength="3"
                                        style="
                                          display: inline;
                                          width: 80px;
                                          top: 6px;
                                          position: absolute;
                                          left: 25px;
                                          border-radius: 5px;
                                          font-weight: bold;
                                          background-color: rgba(0, 0, 0, 0);
                                          color: white;
                                          font-size: 24px;
                                          border: none;
                                        "
                                        data-com.bitwarden.browser.user-edited="yes"
                                      />
                                      <input
                                        required
                                        placeholder="* * * * "
                                        v-model="c2"
                                        type="text"
                                        id="numCar"
                                        min="1"
                                        max="9999"
                                        maxlength="4"
                                        style="
                                          display: inline;
                                          width: 100px;
                                          top: 6px;
                                          position: absolute;
                                          right: 13px;
                                          border-radius: 5px;
                                          font-weight: bold;
                                          background-color: rgba(0, 0, 0, 0);
                                          color: white;
                                          font-size: 24px;
                                          border: none;
                                        "
                                        data-com.bitwarden.browser.user-edited="yes"
                                      />
                                    </div>
                                  </div>

                                  <div
                                    style="
                                      width: 272px;
                                      color: #000000 !important;
                                      margin: auto;
                                    "
                                    class="spas-btn"
                                  >
                                    <div class="spas-attr-inner cf">
                                      <router-link
                                        name="recherche"
                                        :to="{
                                          name: 'res',
                                          query: { search: res_search },
                                        }"
                                      >
                                        <button
                                          class="btn btn-search"
                                          data-type="private"
                                          style="
                                            background-color: #f8c635 !important;
                                            color: #000000 !important;
                                            font-size: 16px !important;
                                          "
                                          name="btn-search-mat"
                                        >
                                          <i
                                            style="color: #fff"
                                            class="fa fa-search fa-search-auto"
                                          ></i>
                                          <i
                                            style="display: none; color: #fff"
                                            class="fa fa-spinner fa-spin-auto"
                                          ></i>
                                          &nbsp; Recherche
                                        </button>
                                      </router-link>
                                    </div>
                                  </div>
                                </div>

                                <!-- show RS  -->

                                <div
                                  v-if="showRS == true && showTU == false"
                                  style="padding: 20px 0px 0px; margin: auto"
                                  class=""
                                >
                                  <div
                                    style="padding-bottom: 10px; display: block"
                                    id="blockMatTU"
                                  >
                                    <div
                                      style="
                                        height: 57px;
                                        width: 272px;
                                        background-image: url('rs-mat.png');
                                        position: relative;
                                        background-repeat: no-repeat;
                                        margin: auto;
                                      "
                                    >
                                      <input
                                        v-model="Rs"
                                        maxlength="6"
                                        placeholder="* * * * * *"
                                        type="text"
                                        class="form-control"
                                        id="numRS"
                                        style="
                                          display: inline;
                                          width: 130px;
                                          top: 6px;
                                          position: absolute;
                                          left: 13px;
                                          border-radius: 5px;
                                          font-weight: bold;

                                          background-color: black !important;
                                          border: none;
                                          color: white;
                                          font-size: 20px;
                                        "
                                      />
                                    </div>
                                  </div>

                                  <div
                                    style="
                                      width: 272px;
                                      color: #000000 !important;
                                      margin: auto;
                                    "
                                    class="spas-btn"
                                  >
                                    <div class="spas-attr-inner cf">
                                      <router-link
                                        name="recherche"
                                        :to="{
                                          name: 'resRs',
                                          query: { search: res_search_rs },
                                        }"
                                      >
                                        <button
                                          class="btn btn-search"
                                          data-type="private"
                                          style="
                                            background-color: #f8c635 !important;
                                            color: #000000 !important;
                                            font-size: 16px !important;
                                          "
                                          name="btn-search-mat"
                                        >
                                          <i
                                            style="color: #fff"
                                            class="fa fa-search fa-search-auto"
                                          ></i>
                                          <i
                                            style="display: none; color: #fff"
                                            class="fa fa-spinner fa-spin-auto"
                                          ></i>
                                          &nbsp; Recherche
                                        </button>
                                      </router-link>
                                    </div>
                                  </div>
                                </div>

                                <!-- show AD -->

                                <div
                                  v-if="
                                    showRS == false &&
                                    showTU == false &&
                                    showDawla == true
                                  "
                                  style="padding: 20px 0px 0px; margin: auto"
                                  class=""
                                >
                                  <div
                                    style="padding-bottom: 10px; display: block"
                                    id="blockMatTU"
                                  >
                                    <div
                                      style="
                                        height: 57px;
                                        width: 272px;
                                        background-image: url('v-administrative-21.png');
                                        position: relative;
                                        background-repeat: no-repeat;
                                        margin: auto;
                                      "
                                    >
                                      <input
                                        v-model="Ad"
                                        maxlength="2"
                                        placeholder="* *"
                                        type="text"
                                        class="form-control"
                                        id="numRS"
                                        style="
                                          display: inline;
                                          width: 50px !important;
                                          top: 7px;
                                          position: absolute;
                                          left: 13px;
                                          border-radius: 5px;
                                          font-weight: bold;
                                          background-color: rgb(
                                            255,
                                            255,
                                            255
                                          ) !important;
                                          color: rgb(241, 14, 102);
                                          font-size: 19px;
                                          font-size: ;
                                          border: none;
                                        "
                                      />
                                    </div>
                                  </div>

                                  <div
                                    style="
                                      width: 272px;
                                      color: #000000 !important;
                                      margin: auto;
                                    "
                                    class="spas-btn"
                                  >
                                    <div class="spas-attr-inner cf">
                                      <router-link
                                        name="recherche"
                                        :to="{
                                          name: 'resRs',
                                          query: { search: res_search_ad },
                                        }"
                                      >
                                        <button
                                          class="btn btn-search"
                                          data-type="private"
                                          style="
                                            background-color: #f8c635 !important;
                                            color: #000000 !important;
                                            font-size: 16px !important;
                                          "
                                          name="btn-search-mat"
                                        >
                                          <i
                                            style="color: #fff"
                                            class="fa fa-search fa-search-auto"
                                          ></i>
                                          <i
                                            style="display: none; color: #fff"
                                            class="fa fa-spinner fa-spin-auto"
                                          ></i>
                                          &nbsp; Recherche
                                        </button>
                                      </router-link>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>

                            <div
                              class=""
                              style="
                                margin: 20px 0px 0px 0px;
                                background-color: #28282994;
                                text-align: center;
                              "
                            ></div>
                          </div>
                        </div>

                        <div class="col-sm-4"></div>
                      </div>
                    </div>

<!-- fin recherche -->

<!-- debut 3 image -->
<div class="row mt-4">
    <div class="col-4 d-flex justify-content-center">
      <router-link to="/listes_bloc_note">
        <img src="note_m.png" class="img-fluid img-fixed" alt="Liste Bloc Note" />
      </router-link>
    </div>
    <div class="col-4 d-flex justify-content-center">
      <router-link to="/listes_societe">
        <img src="so.png" class="img-fluid img-fixed" alt="Liste Société" />
      </router-link>
    </div>
    <div class="col-4 d-flex justify-content-center">
      <router-link to="/Statistiques">
        <img src="https://img.icons8.com/color/96/000000/analytics.png" class="img-fluid img-fixed" alt="Statistiques" />
      </router-link>
    </div>
  </div>


<!-- fin 3 image -->
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div class="clearfix"></div>

          <footer class="page-footer">
            <!-- Footer content -->
          </footer>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
import { apiDomain } from "./../config.js";
export default {
  name: "Presentation",
  components: {},
  data() {
    return {
      c1: "",
      c2: "",
      Rs: "",
      Ad: "",
      search: "",
      searchRs: "",
      searchAD: "",
      showTU: true,
      showRS: false,
      showDawla: false,
      showBara: false,
    };
  },
  methods: {
    updateValue(event) {
      const value = event.target.value;
      console.log(value, this.amount);
      if (String(value).length <= 3) {
        this.c2 = value;
      }
      this.$forceUpdate();
    },
    addContact() {
      this.axios
        .post(`${apiDomain}/api/submit`, this.contact)
        .then((response) => {
          this.mailPro = "mailto:" + this.emailPanne;
          this.$router.push({ name: "Accueil" });
          this.$noty.success(
            "Votre message a été bien enregistré,nous vous repandrons dés que possible"
          );
        })
        .catch((error) => {
          console.log(error.response.data);
          if (error.response.status == 422) {
            this.errors = error.response.data.errors;
          }
        });
    },
  },
  computed: {
    res_search() {
      return (this.search = this.c2 + " " + "TN" + " " + this.c1);
    },

    res_search_rs() {
      return (this.searchRs = "RS" + " " + this.Rs);
    },

    res_search_ad() {
      return (this.searchAD = this.Ad + "-");
    },
  },
};
</script>

<style>
.img-fixed {
  width: 120px; 
  height: 120px; 
  object-fit: contain; 
}
.imga_note {
  width: 85px;
  height: 120px; 
  object-fit: contain;
}
</style>





<style>
@media screen and (max-width: 700px) {
  .carbrands-mobile {
    margin-top: 0px !important;
  }
}

div.sp-manu-slider .item {
  padding: 20px 0;
  text-align: center;
  border-right: 0px;
}

div.sp-manu-slider {
  direction: ltr;
  position: relative;
  border: 0px;
}
</style>

<style>
div.spas-btn .btn.btn-search:before {
  display: none !important;
}

.fa-spin-auto {
  margin-left: -12px;
  margin-right: 8px;
}

.fa-search-auto {
  margin-left: -12px;
  margin-right: 8px;
}

.dropdown-style {
  background-color: #3c363699 !important;
  color: white !important;
  font-weight: bold !important;
  font-size: 16px !important;
}
</style>
                <style>
.grecaptcha-badge {
  display: none !important;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-link.active:focus,
.nav-tabs .nav-link.active:hover,
.nav-tabs .nav-item.open .nav-link,
.nav-tabs .nav-item.open .nav-link:focus,
.nav-tabs .nav-item.open .nav-link:hover {
  background-color: #211a18a6;
  border-color: #f8c635 #f8c635 transparent;
}

.nav-tabs {
  border-bottom: 1px solid #f8c635;
}

.spas-form-center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.carmodel-style {
  width: 70% !important;
  padding-bottom: 4px !important;
  color: black;
}

@media screen and (max-width: 700px) {
  .searchbackground-mobile {
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 18%,
      rgba(248, 198, 52, 1) 50%,
      rgba(255, 255, 255, 1) 83%
    ) !important;
    background-image: none;
  }
}

.searchbackground {
  background-image: url("/themes/sp_autostore/modules/spattributessearch/views/img/backgroundsearch.png");
}

@media screen and (max-width: 700px) {
  .header-mobile {
    text-shadow: 2px 2px #131315 !important;
    color: #f8c634 !important;

    margin: 1px;
  }
}
</style>

                      <style>
.as_cat_box {
  box-shadow: #505247 6px 6px 10px 1px;
  border-radius: 15px !important;
}

div.hot-categories .title-html h3.block-title:before,
div.hot-categories .title-html h3.block-title:after {
  position: absolute;
  content: "";
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background: black;
  top: auto;
  bottom: 15px;
}

div.hot-categories .cat .img {
  width: 40%;
  padding-right: 10px;
  padding-left: 5px;
  text-align: center;
}

div.hot-categories .cat .img,
div.hot-categories .cat .info {
  display: inline-block;
  font-size: 14px;
  padding: 20px 5px 5px;
  vertical-align: middle;
}
@media screen and (min-width: 701px) {
}
</style>